import React from 'react'
import {CNavGroup, CNavItem} from '@coreui/react'
import { generateDynamicMenus, buildSettlementNavItems } from './utils/menuUtils'
import { isGameEnabled } from './config/menuConfig'

const Navigation = (props) => {
    const dynamicMenus = generateDynamicMenus();
    
    return [
        {
            id: 0,
            component: CNavItem,
            name: '대시보드',
            to: '/dashboard',
        },
        {
            id: 10,
            component: CNavGroup,
            name: '관리자 설정',
            to: '/admin',
            items: [
                {
                    id: 11,
                    component: CNavItem,
                    name: '관리자 목록',
                    to: '/admin/list',
                },
                // {
                //     id: 12,
                //     component: CNavItem,
                //     name: '파트너 리스트2',
                //     to: '/partner/list2',
                // },
                // {
                //     id: 13,
                //     component: CNavItem,
                //     name: '파트너 생성',
                //     to: '/partner/create',
                // },
            ],
        },
        {
            id: 20,
            component: CNavGroup,
            name: '사용자 관리',
            to: '/user',
            items: [
                // {
                //     id: 21,
                //     component: CNavItem,
                //     name: '회원 생성',
                //     to: '/user/create',
                // },
                {
                    id: 27,
                    component: CNavItem,
                    name: '회원 트리뷰',
                    to: '/user/tree-view',
                },
                {
                    id: 22,
                    component: CNavItem,
                    name: '회원 리스트',
                    to: '/user/list',
                },
                {
                    id: 23,
                    component: CNavItem,
                    name: '로그인 내역',
                    to: '/user/login/history',
                },
                {
                    id: 24,
                    component: CNavItem,
                    name: '가입승인 대기',
                    to: '/user/accept',
                },
                {
                    id: 25,
                    component: CNavItem,
                    name: '머니 내역',
                    to: '/user/cash-history',
                },
                {
                    id: 26,
                    component: CNavItem,
                    name: '포인트 내역',
                    to: '/user/point',
                },
                // {
                //     id: 27,
                //     component: CNavItem,
                //     name: '사용자 추적',
                //     to: '/user/history',
                // },
                {
                    id: 28,
                    component: CNavItem,
                    name: '접속중인 회원',
                    to: '/user/login-user',
                },
                // {
                //     id: 29,
                //     component: CNavItem,
                //     name: '멀티 아이피 내역',
                //     to: '/user/multi-ip',
                // },
            ],
        },
        {
            id: 30,
            component: CNavGroup,
            name: '배팅 내역',
            to: '/betting',
            items: [
                {
                    id: 31,
                    component: CNavItem,
                    name: '배팅내역 조회',
                    to: '/betting/list',
                },
            ]
        },
        {
            id: 40,
            component: CNavGroup,
            name: '입/출금 관리',
            to: '/cash',
            items: [
                {
                    id: 41,
                    component: CNavItem,
                    name: '입금 신청 내역',
                    to: '/cash/in-request',
                },
                {
                    id: 42,
                    component: CNavItem,
                    name: '입금 내역 조회',
                    to: '/cash/in-list',
                },
                {
                    id: 43,
                    component: CNavItem,
                    name: '출금 신청 내역',
                    to: '/cash/withdraw-request',
                },
                {
                    id: 44,
                    component: CNavItem,
                    name: '출금 내역 조회',
                    to: '/cash/withdraw-list',
                },
                {
                    id: 45,
                    component: CNavItem,
                    name: '관리자 지급/회수',
                    to: '/cash/admin',
                },
                // {
                //     id: 46,
                //     component: CNavItem,
                //     name: '캐시 변동내역',
                //     to: '/cash/change-history',
                // },
            ]
        },
        ...buildSettlementNavItems(),
        {
            id: 80,
            component: CNavGroup,
            name: "설정 관리",
            to: '/config',
            items: [
                {
                    id: 83,
                    component: CNavItem,
                    name: "게임 사용설정",
                    to: '/config/use/all'
                },
                {
                    id: 81,
                    component: CNavItem,
                    name: "사이트 설정",
                    to: '/config/site'
                },
                {
                    id: 82,
                    component: CNavItem,
                    name: "레벨별 설정",
                    to: '/config/level'
                },
                {
                    id: 86,
                    component: CNavItem,
                    name: "점검 설정",
                    to: '/config/inspection'
                },
            ],
        },
        // 게임 관리 메뉴 (동적 생성)
        ...(isGameEnabled('sports') || dynamicMenus.minigame.length > 0 ? [{
            id: 60,
            component: CNavGroup,
            name: "게임 관리",
            to: '/games',
            items: [
                // 스포츠 관리 (sports 설정에 따라)
                ...(isGameEnabled('sports') ? [{
                    id: 61,
                    component: CNavItem,
                    name: "스포츠 관리",
                    to: '/game/setting'
                }] : []),
                // 인플레이 관리 (sports 설정에 따라)
                ...(isGameEnabled('sports') ? [{
                    id: 62,
                    component: CNavItem,
                    name: "인플레이 관리",
                    to: '/game/inplay-setting'
                }] : []),
                // 미니게임 관리 (minigame 설정에 따라)
                ...dynamicMenus.minigame
            ]
        }] : []),
        {
            id: 70,
            component: CNavGroup,
            name: "게시판 관리",
            to: '/customer',
            items: [
                {
                    id: 73,
                    component: CNavItem,
                    name: "공지사항",
                    to: '/customer/notice'
                },
                {
                    id: 72,
                    component: CNavItem,
                    name: "이벤트 팝업",
                    to: '/event/list'
                },
                {
                    id: 71,
                    component: CNavItem,
                    name: "쪽지 관리",
                    to: '/message/list'
                },
                {
                    id: 74,
                    component: CNavItem,
                    name: "1:1 문의 관리",
                    to: '/customer/inquiry'
                },
                {
                    id: 75,
                    component: CNavItem,
                    name: "1:1 문의 응답문구 관리 ",
                    to: '/customer/macro'
                },
                {
                    id: 76,
                    component: CNavItem,
                    name: "출석현황",
                    to: '/customer/attendance'
                },
            ],
        },
        {
            id: 85,
            component: CNavGroup,
            name: "쿠폰 관리",
            to: '/coupon',
            items: [
                {
                    id: 86,
                    component: CNavItem,
                    name: "쿠폰템플릿 관리",
                    to: '/coupon/template'
                },
                {
                    id: 87,
                    component: CNavItem,
                    name: "쿠폰 발행",
                    to: '/coupon/issue'
                },
                {
                    id: 88,
                    component: CNavItem,
                    name: "쿠폰 이력 조회",
                    to: '/coupon/history'
                },
            ],
        },
    ];
}

export default Navigation;
